import { HttpErrorService } from '@/services/HttpError.service'
import { eventErrorHandbook } from '@/models/Errors'
import type { EventPageKit } from '@/models'
import { HttpService } from '@/services/Http.service'

export class EventPageKitService {
  private httpErrorService: HttpErrorService<keyof typeof eventErrorHandbook>
  private endpoint = '/event-page-kit/'
  private httpService: HttpService

  constructor(httpService: HttpService) {
    this.httpService = httpService
    this.httpErrorService = new HttpErrorService(
      eventErrorHandbook,
      'event-page-kits',
    )
  }

  /**
   * @param id - если урл события содержит #hashtag, отдаем его в урле запросе
   */
  async getById(id: string | number) {
    const url = [this.endpoint, id].join('')

    return await this.httpService
      .get<EventPageKit>(url, {
        fetchConfig: {
          timeout: 10000,
        },
        requestConfig: {
          cancellable: true,
          needCancelAtChangeRoute: true,
          forceRequest: true,
          needGlobal404: true,
        },
      })
      .catch((error) => {
        throw this.httpErrorService.getThrowingError(error, url)
      })
  }
}
